<div class="flex flex-col gap-4">
    <p class="m-0 text-xs font-semibold uppercase tracking-wide text-secondary">Screening window</p>
    <div class="flex flex-col gap-2">
        <p class="m-0 text-sm font-semibold text-primary">Screen posts from</p>
        <div class="flex flex-wrap gap-2" role="group" aria-label="Screen posts from">
            @for (preset of presets; track preset.id) {
            <button type="button" (click)="selectPreset(preset.id)" [class]="presetClass(preset.id)"
                [attr.aria-pressed]="selectedPreset() === preset.id">{{ preset.label }}</button>
            }
            <button type="button" (click)="chooseCustom()" [class]="presetClass('custom')"
                [attr.aria-pressed]="selectedPreset() === 'custom'">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="size-4" aria-hidden="true">
                    <path d="M8 2v4" />
                    <path d="M16 2v4" />
                    <rect width="18" height="18" x="3" y="4" rx="2" />
                    <path d="M3 10h18" />
                </svg>
                Custom
            </button>
        </div>
    </div>

    @if (selectedPreset() === 'custom') {
    <mat-form-field class="w-full event-date-field bg-transparent">
        <input matInput [matDatepicker]="picker" [min]="minDate" [max]="latestDate"
            [matDatepickerFilter]="pastDatesOnly" [value]="fromDate()" (dateChange)="onDateChange($event)"
            class="event-date-input text-primary" aria-label="Custom screen from date" readonly>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker [dateClass]="dateClass" #picker [startAt]="fromDate() ?? latestDate"></mat-datepicker>
    </mat-form-field>
    }

    <div class="flex items-center justify-between gap-3 rounded-xl bg-muted px-4 py-3">
        <div class="flex min-w-0 items-center gap-4">
            <div>
                <p class="m-0 text-xs font-semibold uppercase tracking-wide text-secondary">From</p>
                <p class="m-0 text-base font-bold text-primary">{{ fromLabel() }}</p>
            </div>
            <span class="text-secondary" aria-hidden="true">→</span>
            <div>
                <p class="m-0 text-xs font-semibold uppercase tracking-wide text-secondary">To</p>
                <p class="m-0 text-base font-bold text-primary">{{ toLabel() }}</p>
            </div>
        </div>
        @if (dayCount(); as days) {
        <span class="shrink-0 rounded-full bg-brand-studio/10 px-3 py-1 text-xs font-semibold text-brand-studio">{{ days }} days</span>
        }
    </div>

    <div>
        <div class="relative pt-5">
            <span class="absolute right-0 top-0 text-xs text-secondary">Today</span>
            <div class="relative h-2 rounded-full bg-border" aria-hidden="true">
                <div class="absolute inset-y-0 rounded-full bg-brand-studio"
                    [style.left.%]="fill().left" [style.width.%]="fill().width"></div>
                <span class="absolute -top-1 right-0 h-4 w-px bg-gray-900 dark:bg-white"></span>
            </div>
        </div>
        <div class="mt-2 flex justify-between text-xs text-secondary">
            <span>{{ yearAgoLabel() }}</span>
            <span>{{ toLabel() }}</span>
        </div>
    </div>

    <div class="flex flex-wrap items-center justify-between gap-3">
        <p class="m-0 text-sm text-secondary">Screening looks back from today, up to 1 year.</p>
        <button type="button" (click)="useRange()" [disabled]="!fromDate()"
            class="btn-shout btn-shout-sm btn-shout-primary shrink-0">Use this range →</button>
    </div>
</div>
